import { Group } from "@fairfleet/geotab";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGroups } from "@/hooks/groups/useGroups";
import { RememberedGroups, useRememberedGroups } from "@/hooks/userState/useRememberedGroups";

/**
 * Remembers the header group filter and puts it back on load.
 *
 * Must be used by something that is mounted for the whole session (the page header), not by the
 * select itself: below 1400px the select lives in a drawer that only exists while it is open, so
 * a restore owned by the select would not happen until the user opened the drawer.
 */
export function useGroupFilterMemory(): RememberedGroups<Group> {
  const { data: allGroups } = useGroups();
  const { groups, updateGroups } = useAddInState();

  return useRememberedGroups({
    available: allGroups,
    selected: groups,
    onRestore: updateGroups,
  });
}
